/**
 * Funciones de ayuda para la vista TicketDetailView
 */

/**
 * Normaliza las propiedades del ticket con datos reales sin usar placeholders estáticos
 * @param {object} propTicket 
 * @returns {object}
 */
export const normalizeTicketData = propTicket => {
  if (!propTicket) {
    return {
      id: '',
      idTicket: '',
      customerName: '',
      vCustomerName: '',
      initials: '',
      phone: '',
      ticketPhone: '',
      vTelefono: '',
      avatar: null,
      history: []
    };
  }

  const ticketId = propTicket?.idTicket || propTicket?.id || '';
  const customerName = propTicket?.vCustomerName || propTicket?.customerName || propTicket?.name || propTicket?.vNombreContacto || (propTicket?.vUsername ? `@${propTicket.vUsername}` : '') || '';
  const initials = customerName 
    ? customerName.trim().split(' ').filter(Boolean).map(w => w[0]).join('').substring(0, 2).toUpperCase() 
    : '';
  const phone = propTicket?.vTelefono || propTicket?.phone || propTicket?.ticketPhone || propTicket?.vUserId || propTicket?.vFromUserId || '';

  return {
    ...propTicket,
    id: ticketId,
    idTicket: ticketId,
    customerName,
    vCustomerName: customerName,
    initials,
    phone,
    ticketPhone: phone,
    vTelefono: propTicket?.vTelefono || '',
    vUserId: propTicket?.vUserId || propTicket?.vFromUserId || '',
    vFromUserId: propTicket?.vFromUserId || propTicket?.vUserId || '',
    vUsername: propTicket?.vUsername || '',
    vNombreContacto: propTicket?.vNombreContacto || '',
    bReabierto: propTicket?.bReabierto ?? propTicket?.isReopened ?? false,
    isReopened: propTicket?.bReabierto ?? propTicket?.isReopened ?? false,
    avatar: propTicket?.avatar || null,
    history: propTicket?.history || []
  };
};

/**
 * Crea un objeto de mensaje local para cuando el agente escribe
 * @param {string} text 
 * @param {string} authorName
 * @returns {object}
 */
export const createAgentMessage = (text, authorName = 'Tú') => {
  return {
    idMensaje: Date.now(),
    bEsAgente: true,
    idCatTipoMensaje: 1,
    vTextoMensaje: text,
    vCreatedUser: authorName,
    dCreatedDate: new Date().toISOString()
  };
};
